import { useAuthModal } from 'authOld/hooks';
import { IAuthUser } from 'authOld/types';
import { useSwitchUserVersionContext } from 'core/states';
import { DropdownOptions } from 'coreOld/types';

import ProfileNavView from './ProfileNavView';

interface IProps {
  user?: IAuthUser;
  openedDropdown: DropdownOptions;
  toggleDropdown: (name: string) => void;
  collapsedMenu?: boolean;
}

const ProfileNav = ({ user, openedDropdown, toggleDropdown, collapsedMenu = false }: IProps) => {
  const { openedAuthModal, openAuthModal, closeAuthModal } = useAuthModal();
  const { onUserVersionChange } = useSwitchUserVersionContext();

  return (
    <ProfileNavView
      user={user}
      collapsedMenu={collapsedMenu}
      openedDropdown={openedDropdown}
      toggleDropdown={toggleDropdown}
      openedAuthModal={openedAuthModal}
      openAuthModal={openAuthModal}
      closeAuthModal={closeAuthModal}
      onUserVersionChange={onUserVersionChange as any}
    />
  );
};

export default ProfileNav;
